import DPD from './DPD.component';

export default DPD;